// @flow
import types from "./types";
import type {Action} from "../DucksUtils";
import CurrentRequestTypes from "../CurrentRequest/types";

export type DestAutocomplete = {|
    address: string,
|}

export const DestAutocompleteDefault = {
    address: "",
};

const DestAutocompleteReducer = (destAutocomplete: DestAutocomplete = DestAutocompleteDefault, action: Action): DestAutocomplete => {
    const type: string = action.type;
    const payload = action.payload;
    switch (type) {
        case types.DEST_INPUT_SET:
            return {
                address: payload
            };
        case CurrentRequestTypes.DEST_LABEL_CLICK:
            return {
                address: "",
            };
        default:
            return destAutocomplete;

    }
};

export default DestAutocompleteReducer;


// WEBPACK FOOTER //
// ./src/Store/Ducks/DestAutocomplete/reducers.js